"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortFields = void 0;
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var connected_react_router_1 = require("connected-react-router");
var createPathByFilters_1 = __importDefault(require("../../utils/createPathByFilters"));
var track_event_1 = __importDefault(require("../../../../utils/track-event"));
var selectors_1 = require("../../selectors");
var selectors_2 = require("../../../common/selectors");
var GenericSelect_1 = __importDefault(require("../../../common/GenericSelect"));
var styled_components_1 = __importDefault(require("styled-components"));
exports.sortFields = [
    'admin_rating',
    'price_asc',
    'moderated_date',
];
var SortBy = function () {
    var isCustomStore = (0, react_redux_1.useSelector)(selectors_2.isCustomStoreSelector);
    var sort = (0, selectors_1.useSortSelector)();
    var filters = (0, selectors_1.useFiltersSelector)(isCustomStore);
    var search = filters.search;
    var disabled = filters.loading;
    var _a = (0, react_1.useState)(filters.sort), sortTypeValue = _a[0], setSortTypeValue = _a[1];
    var dispatch = (0, react_redux_1.useDispatch)();
    var handleChangeOfSelect = function (value) {
        var sortType = value;
        if (!isSortField(sortType))
            return;
        setSortTypeValue(sortType);
        var url = (0, createPathByFilters_1.default)(filters, {
            sort: sortType,
        });
        dispatch((0, connected_react_router_1.push)({
            pathname: url,
            search: search,
            hash: '',
        }));
        sendTracker(sortTypeValue);
    };
    var sendTracker = function (sortType) {
        var sortTypeMap = {
            admin_rating: 'rating',
            price_asc: 'price',
            moderated_date: 'date',
        };
        (0, track_event_1.default)({
            category: 'store button',
            action: "Sort by ".concat(sortTypeMap[sortType], " click"),
            label: filters.combine,
        });
    };
    return (react_1.default.createElement(Container, null,
        react_1.default.createElement(GenericSelect_1.default, { disabled: disabled, value: sortTypeValue, onChange: handleChangeOfSelect, options: sort.map(function (option) { return ({
                label: option.title,
                value: option.type,
            }); }) })));
};
var isSortField = function (sortType) {
    return exports.sortFields.includes(sortType);
};
var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 10px;\n\n  @media (max-width: 940px), (hover: none) {\n    margin-top: 0px;\n    margin-bottom: 12px;\n\n    .generic-select {\n      width: 100%;\n    }\n  }\n"], ["\n  margin-top: 10px;\n\n  @media (max-width: 940px), (hover: none) {\n    margin-top: 0px;\n    margin-bottom: 12px;\n\n    .generic-select {\n      width: 100%;\n    }\n  }\n"])));
exports.default = SortBy;
var templateObject_1;
